import React, { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { productTypeTire } from "../../../../constants/productTypes";
import { FiltersGroup } from "../../../FiltersSidebar/FiltersGroup";
import { FiltersPanel } from "../../../FiltersSidebar/FiltersPanel";
import { useTireResults } from "../useTireResults";
import { TireApprovedBrandFilters } from "./ApprovedBrand/ApprovedBrandFilters";
import { TireCategoryFilters } from "./Category/Category";
import { TireOriginalEquipmentFilters } from "./OriginalEquipment/OriginalEquipment";
import { TireRunFlatFilters } from "./RunFlat/RunFlatFilters";
import { TireBrandFilters } from "./TireBrandFilters/TireBrandFilters";
import { TireLoadRaitingFilters } from "./TireLoadRaitingFilters/TireLoadRaitingFilters";
import { TirePlyRaitingFilters } from "./TirePlyRaitingFilters/TirePlyRaitingFilters";
import { TirePriceFilters } from "./TirePriceFilters/TirePriceFilters";
import { TireSeasonFilters } from "./TireSeasonFilters/TireSeasonFilters";
import { TireSizeFilters } from "./TireSizeFilters/TireSizeFilters";
import { TireSpeedIndexFilters } from "./TireSpeedIndexFilters/TireSpeedIndexFilters";

export const TireFilters: FunctionComponent<{
  children?: ReactNode;
  onClose(): void;
}> = ({ children, onClose }) => {
  const { isLoading } = useTireResults();
  const { t } = useTranslation();
  const tireSections = (
    <>
      <TireSeasonFilters />
      <TireSizeFilters />
      <TireOriginalEquipmentFilters />
      <TireApprovedBrandFilters />
      <TireCategoryFilters />
      <TireRunFlatFilters />
      <TireBrandFilters />
      <TirePriceFilters />
      <TireLoadRaitingFilters />
      <TireSpeedIndexFilters />
      <TirePlyRaitingFilters />
    </>
  );
  return (
    <FiltersPanel loading={isLoading} onClose={onClose}>
      {children ? (
        <>
          <FiltersGroup label={t(`dealerProducts.${productTypeTire}`)}>
            {tireSections}
          </FiltersGroup>
          {children}
        </>
      ) : (
        tireSections
      )}
    </FiltersPanel>
  );
};

/**
 * @see docs/worklog/TW-859-combos-wheel-filters/rfc.md
 * @see docs/worklog/TW-859-combos-wheel-filters/tfc.md
 */
